import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

const AgrivitechCheckbox = ({
  interactable,
  isChecked,
  icon,
  style_checkbox,
}) => {
  const [checked, setChecked] = useState(isChecked);

  const handleCheckboxChange = () => {
    if (!interactable) return;
    setChecked(!checked);
  };

  return (
    <label
      className={`tw-relative tw-inline-block tw-w-4 tw-h-4 tw-rounded-[5px] tw-transition tw-duration-300 tw-border-[1px] ${!checked ? 'tw-border-solid tw-border-text-dark-medium-importance' : ''} ${interactable ? 'tw-cursor-pointer' : 'tw-cursor-auto'}`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleCheckboxChange}
        className="tw-absolute tw-opacity-0 tw-w-0 tw-h-0"
      />
      <span
        className={`tw-flex tw-items-center tw-justify-center tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-rounded-[5px] tw-border-0 tw-transition tw-duration-300 ${checked && style_checkbox ? style_checkbox : ''}`}
      >
        {checked && (
          <FontAwesomeIcon
            icon={icon || faCheck}
            className="tw-text-white tw-w-3 tw-h-3"
          />
        )}
      </span>
    </label>
  );
};

export default AgrivitechCheckbox;
